/* Copyright (c) 2022 MOCA Systems, Inc.  All rights reserved. */

import { ILoggerTransport } from './ILoggerTransport';
import { ILogEntry } from './ILogEntry';

export class ConsoleLoggerTransport implements ILoggerTransport {
	public transportMessage(logEntry: ILogEntry): void {
		const loc = logEntry.logCallLocation;
		const prefix = loc ? logEntry.prefix + ` [${loc.fileName}:${loc.lineNumber}]` : logEntry.prefix;

		// if the message isn't a string, send prefix as a separate parameter
		// else combine them in a single string message
		const message =
			typeof logEntry.message !== 'string' ? [prefix, logEntry.message] : [prefix + ' ' + logEntry.message];

		switch (logEntry.logLevel) {
			case 'log':
				console.log(...message, ...logEntry.optionalParams);
				break;
			case 'debug':
				console.debug(...message, ...logEntry.optionalParams);
				break;
			case 'warn':
				console.warn(...message, ...logEntry.optionalParams);
				break;
			case 'error':
				console.error(...message, ...logEntry.optionalParams);
				break;
			case 'verbose':
				console.log(...message, ...logEntry.optionalParams);
				break;
		}
	}
}
